const configTypes = {
  local: {
    emilyURL: 'https://leads.clear.link',
    lapiURL: 'https://lapi.dev.aws.clear.link',
    mapiZipURL: 'https://m.clear.link/zip_code/',
    tcpaURL: 'https://proof.clear.link',
    cobraURL: 'https://cobra.stage.clear.link/domain/availability?domain=',
    chatURL: 'https://cdn.stage.clear.link/twilio/index.js',
    chatApiURL: 'https://chat.stage.clear.link/dummy',
    ubioServerURL: 'http://ubio.local',
  },
  development: {
    emilyURL: 'https://leads.clear.link',
    lapiURL: 'https://lapi.clear.link',
    mapiZipURL: 'https://m.clear.link/zip_code/',
    tcpaURL: 'https://proof.clear.link',
    cobraURL: 'https://cobra.clear.link/domain/availability?domain=',
    chatURL: 'https://cdn.stage.clear.link/twilio/index.js',
    chatApiURL: 'https://chat.stage.clear.link/dummy',
    ubioServerURL: 'https://ubio-server.stage.clear.link',
  },
  staging: {
    emilyURL: 'https://leads.clear.link',
    lapiURL: 'https://lapi.dev.aws.clear.link',
    mapiZipURL: 'https://m.clear.link/zip_code/',
    tcpaURL: 'https://proof.clear.link',
    cobraURL: 'https://cobra.stage.clear.link/domain/availability?domain=',
    chatURL: 'https://cdn.stage.clear.link/twilio/index.js',
    chatApiURL: 'https://chat.stage.clear.link/dummy',
    ubioServerURL: 'https://ubio-server.stage.clear.link',
  },
  production: {
    emilyURL: 'https://leads.clear.link',
    lapiURL: 'https://lapi.clear.link',
    mapiZipURL: 'https://m.clear.link/zip_code/',
    tcpaURL: 'https://proof.clear.link',
    cobraURL: 'https://cobra.clear.link/domain/availability?domain=',
    chatURL: 'https://cdn.clear.link/twilio/index.js',
    chatApiURL: 'https://chat.clear.link',
    ubioServerURL: 'https://ubio-server.clear.link',
  },
}

const environment = process.env.LOCATION || 'local'
let serviceURLs = configTypes[environment]
if (!serviceURLs) {
  serviceURLs = configTypes.local
  // eslint-disable-next-line no-console
  console.error(
    'Leshen:UI - `LOCATION` environment variable did not match any known environment config. Falling back to `local` environment config.'
  )
}

module.exports = {
  environment,
  serviceURLs,
}
